import { BrowserRouter } from 'react-router-dom';

import { Navbar } from 'components';
import ErrorBoundary from 'components/ErrorBoundary';
import { AgentRoleContextProvider } from 'hooks/useAgentRoleContext';
import { DictionaryContextProvider } from 'hooks/useDictionaryContext';
import { DocumentContextProvider } from 'hooks/useDocumentContext';

import ContentWrapper from './components/ContentWrapper';
import EnvironmentBanner from './components/EnvironmentBanner';

const App = () => {
  return (
    <BrowserRouter>
      <DictionaryContextProvider>
        <AgentRoleContextProvider>
          <DocumentContextProvider>
            <div className="flex">
              <EnvironmentBanner />
              <Navbar />
              <ErrorBoundary>
                <ContentWrapper />
              </ErrorBoundary>
            </div>
          </DocumentContextProvider>
        </AgentRoleContextProvider>
      </DictionaryContextProvider>
    </BrowserRouter>
  );
};

export default App;
